<template>
  <v-card color="primary" :disabled="loading">
    <v-progress-linear v-show="loading" color="white" indeterminate></v-progress-linear>
    <v-card-text>
      <v-row>
        <v-col cols="2" class="text-title-card">
          <v-icon x-large dark> mdi-chart-bell-curve-cumulative </v-icon>
        </v-col>
        <v-col class="text-right text-title-card">
            <v-row no-gutters>
                <v-col>
                    AVANÇO FÍSICO
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col>
                    {{formatMoneyPrecision1(realizado_percentage)}} %
                </v-col>
            </v-row>

          <!-- <v-menu botton offset-x>
            <template v-slot:activator="{ on, attrs }">
              <v-btn dark icon v-bind="attrs" v-on="on">
                <v-icon dark>mdi-dots-vertical </v-icon>
              </v-btn>
            </template>
            <v-card>
              <div style="padding: 5px">dsfsdf</div>
              <v-divider></v-divider>
              <v-list>
                <v-list-item @click="setCost(cost)" v-for="(cost,index) in costs" :key="index">
                    {{ cost.name }}
                </v-list-item>
              </v-list>
            </v-card>
          </v-menu> -->
        </v-col>
      </v-row>
    <v-row no-gutters class="text-data-card mt-4">
        <v-col>HH REALIZADO</v-col>
        <v-col class="text-right">{{ formatMoney(realizado) }} </v-col>
      </v-row>
      <v-row no-gutters class="text-data-card ">
        <v-col>HH TOTAL</v-col>
        <v-col class="text-right"> {{ formatMoney(previsto) }} </v-col>
      </v-row>

    </v-card-text>
  </v-card>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "PhysicalProgress",
  data() {
    return {
      realizado_percentage:0,
      previsto: 0.0,
      realizado: 0.0,
      loading: false,
      costs:[],
      selectedCost:{},
    };
  },
  created() {
    this.getCosts()
    this.getPhysicalProgress();
  },
  methods: {
    ...mapActions("Dashboard", ["getPhysicalProgressPercentageGlobal",'getCostAll','setSelectedCost']),
    getPhysicalProgress() {
      this.loading = true;
      this.getPhysicalProgressPercentageGlobal()
        .then((reponse) => {
          this.previsto = reponse.data.hh_previsto;
          this.realizado = reponse.data.hh_realizado;
          this.realizado_percentage = reponse.data.hh_realizado_percentage;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCosts(){
        this.getCostAll().then((response)=>{
            this.costs = response.data
        }).finally(()=>{

        })
    },
    setCost(cost){
        this.loading = true;
        this.setSelectedCost(cost).then((response)=>{
          this.previsto = response.data.hh_previsto;
          this.realizado = response.data.hh_realizado;
          this.selectedCost =response.data.cost
        }).finally(()=>{
            this.loading = false;
        })
    },
    formatMoney(number) {
      number = this.parseNumber(number);
      return number.toLocaleString("pt-br", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    formatMoneyPrecision1(number) {
      number = this.parseNumber(number);
      return number.toLocaleString("pt-br", {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      });
    },

    parseNumber(number) {
      if (isNaN(number)) {
        return 0;
      }
      let result = parseFloat(number);
      return result;
    },
  },
};
</script>

<style scoped>
.text-title-card {
  color: white;
  font-size: 20px;
  font-weight: bold;
}
.text-data-card {
  color: white;
  font-size: 14px;
  font-weight: bold;
}
</style>
